import { MIC_CHOICE_KEY_PREFIX } from "@common/lib/accountScopedStorageKeyPrefixes";

export interface SavedMicChoice {
    deviceId: string;
    label: string;
}

// Device-wide on purpose: the microphone belongs to the workstation, not the signed-in user.
export const loadMicChoice = (): SavedMicChoice | null => {
    try {
        const raw = localStorage.getItem(MIC_CHOICE_KEY_PREFIX);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed.deviceId === "string" && typeof parsed.label === "string") {
            return { deviceId: parsed.deviceId, label: parsed.label };
        }
        return null;
    } catch {
        return null;
    }
};

export const saveMicChoice = (choice: SavedMicChoice): void => {
    try {
        localStorage.setItem(MIC_CHOICE_KEY_PREFIX, JSON.stringify(choice));
    } catch {
        // Storage can be blocked; the choice just won't be remembered.
    }
};
